import { call, put, takeEvery } from "redux-saga/effects";
import { setInstaceTypes, setIsLoadingInstanceTypes } from "./slice";
import { InstanceTypesResponse } from "../types";
import { getInstanceTypes } from "services/utilityService";

function* callToloadInstanceTypes() {
  try {
    yield put(setIsLoadingInstanceTypes(true));
    const response: InstanceTypesResponse = yield call(getInstanceTypes);
    yield put(setInstaceTypes(response));
  } catch (error) {
    console.log("Error", error);
  } finally {
    yield put(setIsLoadingInstanceTypes(false));
  }
}

function* callToloadInstanceTypesWatcher() {
  yield takeEvery(
    "mlops/callToLoadInstanceTypes",
    callToloadInstanceTypes
  );
}

export { callToloadInstanceTypesWatcher };
